import React from "react";
import styled from "@emotion/styled";
import { TextField } from "@mui/material";

const StyledInput = styled(TextField)`
  width: 100%;
  font-size: 16px;

  & .MuiInputBase-root {
    height: 56px !important;
    padding-left: 10px;
    padding-right: 10px;
    background-color: #091d35 !important;

    &:hover {
      border-color: rgba(0, 0, 0, 0.08) !important;
    }

    & .MuiInputAdornment-root {
      & .MuiButtonBase-root.MuiIconButton-root {
        &:hover {
          background-color: ${({ theme }) => theme.palette.grey.g2} !important;
        }
      }
    }
  }

  & .MuiOutlinedInput-input {
    color: #ffffff !important; /* ✅ رنگ متن سفید */
    background-color: #091d35 !important;
  }

  & .MuiInputLabel-root {
    color: #ffffff !important; /* ✅ رنگ لیبل سفید */
  }

  & .Mui-focused {
    &:hover {
      border-color: rgba(0, 0, 0, 0.08) !important;
    }
  }

  &:hover {
    border-color: rgba(0, 0, 0, 0.08) !important;
  }
`;

const TrackingInput = ({ ...props }) => <StyledInput {...props} />;

export default TrackingInput;
